import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { getProviderByid } from '../requests'

export const useGetProviderById = (providerId: string) => {
  const programId = useSelector(selectProgramID)

  return useQuery({
    queryKey: ['provider', programId, providerId],
    queryFn: () =>
      getProviderByid({
        program_id: programId,
        provider_id: providerId,
      }),
  })
}
